import './Monitor.css'
import AssetSidebar, { useAssetSelectionState } from '../../menu/AssetMenu'
import { Outlet, useOutletContext } from 'react-router-dom'

const DashboardsTab = () => {

    const { assetFrameworkServices } = useOutletContext()
    const [selectedPortfolioId, selectedSiteId, updatePortfolioId, updateSiteId] = useAssetSelectionState()
    const monitorTabServices = {
        selectedPortfolioId: selectedPortfolioId,
        selectedSiteId: selectedSiteId
    }

    return (
        <div className="flow-horizontal fill-parent">
            <AssetSidebar
                updateSelectedSite={updateSiteId} 
                updateSelectedPortfolio={updatePortfolioId}
                selectedSiteId={selectedSiteId}
                selectedPortfolioId={selectedPortfolioId}
                className="sidebar"
                menuProps={{
                    collapsable: true,
                    style: {borderTop: "solid var(--border-light) 1px"}
                }}
            />
            <div className="section-main flow-vertical fill-parent">
                <Outlet context={{
                    assetFrameworkServices,
                    monitorTabServices
                }} />
            </div>
        </div>
    )
}

export default DashboardsTab